if (window.innerWidth < 992) {
    document.addEventListener('DOMContentLoaded', function () {
        var productCards = new Splide('.wls-product-cards__slider', {
            type: 'slide',
            perPage: 2,
            autoplay: false,
            gap: 16,
            interval: 1250,
            pagination: false,
            arrows: true,
            breakpoints: {
                500: {
                    perPage: 1,
                }
            },
        });

        productCards.mount();
    });
}
document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.wls-product-cards__slider');
    if (!slider) return;

    const slidesCount = slider.querySelectorAll('.splide__slide').length;

    if (window.innerWidth > 991 && slidesCount >= 4) {
        new Splide(slider, {
            type: 'slide',
            perPage: 3,
            gap: 16,
            pagination: false,
            arrows: true,
        }).mount();
    }
});